import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import type { CameraState, VideoBroadcastWidgetState } from '../store/VideoBroadcastWidgetState';

import { AdditionalInfo } from './AdditionalInfo';
import { SyncedHlsVideoPlayer } from './SyncedHlsVideoPlayer';
import styles from './VideoBroadcastWidget.module.scss';

interface Props {
  widgetState: VideoBroadcastWidgetState;
  camera: CameraState;
  active: boolean;
}

export const CameraEntity = observer(function CameraEntity({ widgetState, camera, active }: Props) {
  const { t } = useTranslation('videoBroadcastWidget', { useSuspense: false });

  if (!active) {
    return <div className={styles.broadcastContainer} aria-hidden="true" />;
  }

  return (
    <div className={styles.broadcastContainer}>
      <SyncedHlsVideoPlayer
        camera={camera}
        widgetState={widgetState}
        title={camera.data.cameraName ?? 'video'}
        camNameAvailable={widgetState.additionalInfo.camName}
        additionalInfoElement={
          <AdditionalInfo
            widgetState={widgetState}
            holeDepthLabel={t('sidebar.holeDepth')}
            bitDepthLabel={t('sidebar.bitDepth')}
          />
        }
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
});
